export const KDSPrimengComponents = {
  chip: {
    removeIcon: {
      size: '18px',
      color: '{kds.filterTagRemoveIconColor}',
    },
    root: {
      color: '{kds.filterTagTextColor}',
      background: '{kds.filterTagBackground}',
      gap: '4px',
    },
  },
  autocomplete: {
    placeholder: {
      color: '{kds.tagsInputPlaceholderColor}',
    },
    padding: {
      x: '8px',
      y: '4px',
    },
    hover: {
      border: {
        color: '{kds.tagsInputHoverBorderColor}',
      },
    },
    focus: {
      border: {
        color: '{kds.tagsInputFocusBorderColor}',
      },
    },
    border: {
      color: '{kds.tagsInputBorderColor}',
      radius: '4px',
    },
    chip: {
      border: {
        radius: '4px',
      },
    },
    invalid: {
      border: {
        color: '{kds.tagsInputInvalidBorderColor}',
      },
    },
    list: {
      padding: '4px 0',
    },
    option: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
      focusBackground: '{kds.selectOptionFocusBackground}',
      selectedBackground: '{kds.selectOptionSelectedBackground}',
      selectedColor: '{kds.selectOptionSelectedColor}',
      selectedFocusBackground: '{kds.selectOptionSelectedFocusBackground}',
      selectedFocusColor: '{kds.selectOptionSelectedColor}',
    },
    optionGroup: {
      color: '{kds.selectOptionGroupColor}',
      background: '{kds.selectOptionGroupBackground}',
      padding: '5px 12px',
    },
    emptyMessage: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
    },
  },
  checkbox: {
    width: '14px',
    height: '14px',
    background: '{kds.checkboxBackground}',
    border: {
      color: '{kds.checkboxBorderColor}',
      radius: '2px',
      width: '1.5px',
    },
    transition: {
      duration: '0.2s',
    },
    hover: {
      border: {
        color: '{kds.checkboxBorderHoverColor}',
      },
    },
    focus: {
      border: {
        color: '{kds.checkboxBorderFocusColor}',
      },
    },
    checked: {
      background: '{kds.checkboxCheckedBackground}',
      border: {
        color: '{kds.checkboxCheckedBorderColor}',
        width: '0',
      },
      hover: {
        background: '{kds.checkboxCheckedHoverBackground}',
        border: {
          color: '{kds.checkboxCheckedHoverBorderColor}',
        },
      },
      disabled: {
        background: '{kds.checkboxCheckedDisabledBackground}',
        border: {
          color: '{kds.checkboxCheckedDisabledBorderColor}',
        },
      },
    },
    icon: {
      size: '0.625rem',
      checked: {
        color: '{kds.checkboxCheckedIconColor}',
      },
    },
    disabled: {
      background: '{kds.checkboxDisabledBackground}',
      border: {
        color: '{kds.checkboxDisabledBorderColor}',
      },
    },
  },
  select: {
    root: {
      padding: {
        x: '8px',
        y: '4px',
      },
      background: 'transparent',
      shadow: 'none',
      color: '{kds.selectLabelColor}',
      placeholderColor: '{kds.selectPlaceholderColor}',
      disabledColor: '{kds.selectDisabledLabelColor}',
      disabledBackground: 'transparent',
      border: {
        radius: '4px',
      },
      hover: {
        border: {
          color: 'transparent',
        },
      },
      focus: {
        border: {
          color: 'transparent',
        },
      },
    },
    dropdown: {
      color: '{kds.selectDropdownColor}',
      width: '30px',
      padding: '0 8px 0 6px',
    },
    overlay: {
      background: '{kds.selectOverlayBackground}',
      border: 'unset',
      borderRadius: '4px',
      color: '{kds.selectOverlayColor}',
      shadow: '{kds.selectOverlayShadow}',
    },
    list: {
      padding: '4px 0',
    },
    option: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
      focusBackground: '{kds.selectOptionFocusBackground}',
      selectedBackground: '{kds.selectOptionSelectedBackground}',
      selectedColor: '{kds.selectOptionSelectedColor}',
      selectedFocusBackground: '{kds.selectOptionSelectedFocusBackground}',
      selectedFocusColor: '{kds.selectOptionSelectedColor}',
    },
    optionGroup: {
      color: '{kds.selectOptionGroupColor}',
      background: '{kds.selectOptionGroupBackground}',
      padding: '5px 12px',
    },
    emptyMessage: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
    },
  },
  multiselect: {
    root: {
      padding: {
        x: '8px',
        y: '0',
      },
      background: 'transparent',
      shadow: 'none',
      color: '{kds.selectLabelColor}',
      placeholderColor: '{kds.selectPlaceholderColor}',
      disabledColor: '{kds.selectDisabledLabelColor}',
      disabledBackground: 'transparent',
      border: {
        radius: '4px',
      },
      hover: {
        border: {
          color: 'transparent',
        },
      },
      focus: {
        border: {
          color: 'transparent',
        },
      },
    },
    dropdown: {
      color: '{kds.selectDropdownColor}',
      width: '30px',
      padding: '0 8px 0 6px',
    },
    overlay: {
      background: '{kds.selectOverlayBackground}',
      border: 'unset',
      borderRadius: '4px',
      color: '{kds.selectOverlayColor}',
      shadow: '{kds.selectOverlayShadow}',
    },
    list: {
      padding: '4px 0',
    },
    option: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
      focusBackground: '{kds.selectOptionFocusBackground}',
      selectedBackground: '{kds.selectOptionSelectedBackground}',
      selectedColor: '{kds.selectOptionSelectedColor}',
      selectedFocusBackground: '{kds.selectOptionSelectedFocusBackground}',
      selectedFocusColor: '{kds.selectOptionSelectedColor}',
    },
    optionGroup: {
      color: '{kds.selectOptionGroupColor}',
      background: '{kds.selectOptionGroupBackground}',
      padding: '5px 12px',
    },
    emptyMessage: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
    },
    clearIcon: {
      color: '{kds.selectClearIconColor}',
      size: '16px',
    },
  },
  cascadeselect: {
    root: {
      padding: {
        x: '8px',
        y: '4px',
      },
      background: 'transparent',
      shadow: 'none',
      color: '{kds.selectLabelColor}',
      placeholderColor: '{kds.selectPlaceholderColor}',
      disabledColor: '{kds.selectDisabledLabelColor}',
      disabledBackground: 'transparent',
      border: {
        radius: '4px',
      },
      hover: {
        border: {
          color: 'transparent',
        },
      },
      focus: {
        border: {
          color: 'transparent',
        },
      },
    },
    dropdown: {
      color: '{kds.selectDropdownColor}',
      width: '30px',
      padding: '0 8px 0 6px',
    },
    overlay: {
      background: '{kds.selectOverlayBackground}',
      border: 'unset',
      borderRadius: '4px',
      color: '{kds.selectOverlayColor}',
      shadow: '{kds.selectOverlayShadow}',
    },
    list: {
      padding: '4px 0',
    },
    option: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
      focusBackground: '{kds.selectOptionFocusBackground}',
      selectedBackground: '{kds.selectOptionSelectedBackground}',
      selectedColor: '{kds.selectOptionSelectedColor}',
      selectedFocusBackground: '{kds.selectOptionSelectedFocusBackground}',
      selectedFocusColor: '{kds.selectOptionSelectedColor}',
    },
    emptyMessage: {
      padding: '5px 12px',
      color: '{kds.selectOptionColor}',
    },
  },
  dialog: {
    background: '{kds.dialogBackground}',
    shadow: '{kds.dialogShadow}',
  },
  datatable: {
    header: {
      cell: {
        color: '{kds.datatableHeaderCellColor}',
        padding: '0 16px',
        background: '{kds.datatableHeaderCellBackground}',
        selected: {
          background: '{kds.datatableHeaderCellSelectedBackground}',
        },
        hover: {
          background: '{kds.datatableHeaderCellHoverBackground}',
        },
        border: {
          color: '{kds.datatableHeaderBorderColor}',
        },
      },
    },
    body: {
      cell: {
        padding: '0 16px',
        border: {
          color: '{kds.datatableBodyCellBorderColor}',
        },
      },
    },
    row: {
      background: '{kds.datatableRowBackground}',
      hover: {
        background: '{kds.datatableRowHoverBackground}',
      },
    },
  },
} as const;
